<template>
  <v-row align="end" :class="{ 'pr-3': !disabled }" :no-gutters="disabled">
    <v-col class="pb-0 pr-0" :class="{ 'ordered-by': !disabled }">
      <autocomplete
        :items="suppliers"
        item-text="name"
        item-value="id"
        :label="$t('supplier')"
        :disabled="isLoadingSuppliers || disabled"
        :loading="isLoadingSuppliers"
        :hide-details="hideDetails"
        required
        return-object
        :color="color"
        v-model="model"
      />
    </v-col>
    <v-btn
      v-if="!disabled"
      tile
      depressed
      height="40px"
      @click="supplierDialog = true"
      class="primary px-0 ordered-by-btn"
    >
      <v-icon color="white">mdi-plus-box-outline</v-icon>
    </v-btn>
    <warehouse-supplier-dialog
      v-model="supplierDialog"
      @supplierAdded="handleSupplierSaved"
    />
  </v-row>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import WarehouseSupplierDialog from "../dialogs/WarehouseSupplierDialog.vue";

export default {
  mixins: [hasModel, hasSnackbar],
  name: "ChooseSupplierField",
  props: {
    disabled: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    color: { type: String, default: "default" },
  },
  components: {
    WarehouseSupplierDialog,
  },
  data() {
    return {
      supplierDialog: false,
    };
  },
  computed: {
    suppliers() {
      return this.$store.state.supplier.suppliers;
    },
    isLoadingSuppliers() {
      return this.$store.state.supplier.loading;
    },
  },
  created() {
    this.$store.dispatch("supplier/fetchForUser");
  },
  methods: {
    async handleSupplierSaved() {
      await this.$store.dispatch("supplier/fetchForUser");
      const suppliers = this.$store.state.supplier.suppliers;
      this.model = (suppliers || []).slice(-1)[0];
    },
  },
};
</script>

<style>
.ordered-by .v-input__slot {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ordered-by-btn {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
</style>
